import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from './services/authentication.service';
import {SessionService} from './services/session.service';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private authService: AuthenticationService, private sessionService: SessionService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      this.sessionService.start();

      // Require to change password first
      if (localStorage.getItem('require_to_change_password') === 'true' && state.url !== '/profile/password') {
        this.router.navigate(['/profile', 'password']);
        return false;
      }

      return true;
    }
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const expectedRoles = route.data.expectedRoles;
    const loggedInRole = localStorage.getItem('group');
    if (expectedRoles && expectedRoles.includes(loggedInRole)) {
      return true;
    }
    alert('You are not allowed to view this page');
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/auth-guard.service.ts